import React from "react";
import UIButtonClick from "./UIButtonClick";
import { UIButtonProps } from "./UIButton";
import message from "common/message/source/MessageSource";

export interface UIButtonSearchProps extends UIButtonProps {
  readList: Function;
}

export default UIButtonSearch;

function UIButtonSearch(props: UIButtonSearchProps) {
  return (
    <UIButtonClick
      label={message.get("common.label.read", "조회")}
      {...props}
      onClick={() => {
        props.readList();
      }}
    />
  );
}
